import React from "react";

const PlatformCapabilitiesSection = ({ data }) => (

    <section
        className={`sx-platform-section ${
            data.dark ? "sx-platform-dark" : ""
        }`}
    >

        <div className="container">

            <div className="sx-section-heading">

                <span>
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                </h2>

                {data.description && (
                    <p>
                        {data.description}
                    </p>
                )}

            </div>

            <div className="sx-capability-grid">

                {(data.items || []).map((item, index) => (

                    <div
                        className="sx-capability-card"
                        key={index}
                    >

                        <div className="sx-capability-number">
                            {item.number}
                        </div>

                        <h3>
                            {item.title}
                        </h3>

                        <p>
                            {item.description}
                        </p>

                    </div>

                ))}

            </div>

        </div>

    </section>
);

export default PlatformCapabilitiesSection;